module.exports = __webpack_public_path__ + "img/bingo_ball-82.044d37ff.png";